import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { useScopedTranslation } from 'app/hooks/i18n';
import type { useUser } from 'app/network/user';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';
import type React from 'react';
import { theme } from './shared';

export function ListingBulkActions({
  setShowActions,
  showActions,
  t,
  user,
  onBlockDates,
  onDuplicate,
  canEditPrice,
  onEditPrice,
  loanFeeAvailable,
  onChangeLoanFee,
  showHideButton,
  onHide,
  showUnhideButton,
  onUnhide,
  onDelete,
}: {
  setShowActions: React.Dispatch<React.SetStateAction<boolean>>;
  showActions: boolean;
  t: ReturnType<typeof useScopedTranslation>['t'];
  user: ReturnType<typeof useUser>['data'];
  onBlockDates: () => void;
  onDuplicate: () => void;
  canEditPrice: boolean;
  onEditPrice: () => void;
  loanFeeAvailable: boolean;
  onChangeLoanFee: () => void;
  showHideButton: boolean;
  onHide: () => void;
  showUnhideButton: boolean;
  onUnhide: () => void;
  onDelete: () => void;
}) {
  return (
    <BottomSheet onClose={() => setShowActions(false)} open={showActions}>
      <Column alignItems="center" gap="spacing.general.x2" marginHorizontal="spacing.general.x8">
        <Text fontWeight="700" marginBottom="spacing.general.x2" variant="headerXSmall">
          {t('modifyListingsTitle')}
        </Text>
        {isFeatureEnabled(FeatureFlag.listingPromptAvailability, user?.featureFlags) ? (
          <BottomSheet.ActionButton onPress={onBlockDates} style={{ width: '100%' }} variant="primary">
            {t('blockDatesButton')}
          </BottomSheet.ActionButton>
        ) : null}
        {isFeatureEnabled(FeatureFlag.duplicateListings, user?.featureFlags) ? (
          <BottomSheet.ActionButton
            onPress={onDuplicate}
            style={{ borderColor: theme.colors['surface.inverse.tertiary-neutral'], width: '100%' }}
            variant="secondary"
          >
            {t('duplicateButton')}
          </BottomSheet.ActionButton>
        ) : null}
        {canEditPrice ? (
          <BottomSheet.ActionButton
            onPress={onEditPrice}
            style={{ borderColor: theme.colors['surface.inverse.tertiary-neutral'], width: '100%' }}
            variant="secondary"
          >
            {t('changePriceButton')}
          </BottomSheet.ActionButton>
        ) : null}
        {loanFeeAvailable ? (
          <BottomSheet.ActionButton
            onPress={onChangeLoanFee}
            style={{ borderColor: theme.colors['surface.inverse.tertiary-neutral'], width: '100%' }}
            variant="secondary"
          >
            {t('changeLoanFeeButton')}
          </BottomSheet.ActionButton>
        ) : null}
        {showHideButton ? (
          <BottomSheet.ActionButton
            onPress={onHide}
            style={{ borderColor: theme.colors['surface.inverse.tertiary-neutral'], width: '100%' }}
            variant="secondary"
          >
            {t('hideButton')}
          </BottomSheet.ActionButton>
        ) : null}
        {showUnhideButton ? (
          <BottomSheet.ActionButton
            onPress={onUnhide}
            style={{ borderColor: theme.colors['surface.inverse.tertiary-neutral'], width: '100%' }}
            variant="secondary"
          >
            {t('unhideButton')}
          </BottomSheet.ActionButton>
        ) : null}
        <BottomSheet.ActionButton
          onPress={onDelete}
          style={{ borderColor: theme.colors['surface.inverse.tertiary-neutral'], width: '100%' }}
          variant="delete"
        >
          {t('deleteButton')}
        </BottomSheet.ActionButton>
      </Column>
    </BottomSheet>
  );
}
